import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Expert Software Developers in Washington DC</h2>
            </div>
            <p>
              TekRevol is a customer-centric software developer in Washington
              DC, helping future-oriented enterprises embrace digital
              transformation.
            </p>
            <p>
              Our highly skilled development teams have built exquisite software
              and products for businesses of all sizes, helping them achieve
              exponential growth using technology. As a leading technology
              partner, we assist customers in identifying the most profitable
              growth opportunities and employ our technical expertise to take
              full advantage of them. Using a growth-centric strategy, we
              diligently assist our clients in achieving maximum productivity
              and profitability.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
